import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Field, Form as FinalForm, FormSpy } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage, useIntl } from '../../../../util/reactIntl';
// Import shared components
import { IconClose, FieldTextInput } from '../../../../components';
import { required } from '../../../../util/validators';

import css from './EditListingDetailsForm.module.css';


const FaqFieldArray = props => {

  const intl = useIntl();

  return (
    <FieldArray name="faq">
      {({ fields: dayFields }) => (
        <>
          {dayFields.map((name, index) => (
            <div key={name} className={css.faq}>
              <div className={css.faqTitleHolder}>

                <h3 className={css.faqTitle}>
                  <FormattedMessage id="EditListingDetailsForm.faqTitle" values={{ index: index + 1 }} />
                </h3>
                <button
                  type="button"
                  onClick={() => dayFields.remove(index)}
                  className={css.faqRemoveBtn}
                >
                  <IconClose />
                </button>
              </div>

              <div className={css.faqFields}>
                <FieldTextInput
                  id={`${name}.title`}
                  name={`${name}.title`}
                  type="text"
                  placeholder={intl.formatMessage({
                    id: 'EditListingDetailsForm.faqTitlePlaceholder',
                  })}
                  validate={required(intl.formatMessage({
                    id: 'EditListingDetailsForm.defaultRequiredMessage',
                  }))}
                />
                <FieldTextInput
                  id={`${name}.description`}
                  name={`${name}.description`}
                  type="textarea"
                  placeholder={intl.formatMessage({
                    id: 'EditListingDetailsForm.faqDescriptionPlaceholder',
                  })}
                  validate={required(intl.formatMessage({
                    id: 'EditListingDetailsForm.defaultRequiredMessage',
                  }))}
                />
              </div>
            </div>
          ))}
          <button
            type="button"
            onClick={() => dayFields.push({ id: Date.now(), title: "", description: "" })}
            className={css.faqAddBtn}
          >
            <FormattedMessage id="EditListingDetailsForm.faqAddQuestion" />
          </button>
        </>
      )}
    </FieldArray>
  );
};

export default FaqFieldArray;
